import { render, staticRenderFns } from "./PedidoPagamentoTable.vue?vue&type=template&id=68385abd"
import script from "./PedidoPagamentoTable.vue?vue&type=script&lang=js"
export * from "./PedidoPagamentoTable.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports